// extracted by mini-css-extract-plugin
export default {"container":"styles_container__nBJ5f","header":"styles_header__lrm1b","preview":"styles_preview__ki-u3","history":"styles_history__QlKi7"};